<template>
  <el-form
    ref="landingPassengersDataForm"
    :model="model"
    :rules="rules"
    label-width="10em"
    label-position="left"
    class="landing-passengers-data-form"
  >
    <BillingYm v-model="billingYm" :required="!searchMode" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :actualprop=true :actualmode=2 />
    <BillToCode v-model="billToCode" label="請求先" :required="!searchMode" :searchCond="searchMode"
      :autocomplete-list="autocompleteCustomerCodeSet" :disabled="editMode || decisionDisabled()"/>
    <AirportCode v-model="departureAirportCode" label="出発地" prop="departure_airport_code"
      :required="!searchMode" :searchCond="searchMode" :disabled="editMode"
      :autocomplete-list="autocompleteAirportCodeSet" />
    <AircraftWeightType v-model="aircraftWeightType" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
    <!-- <Seats v-model="seats" :required="!searchMode" :searchCond="searchMode"/> -->
    <Numeric v-model="seats" label="座席数" placeholder="0～999999" prop="seats" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode" :min="0" :max="999999" :step="1"/>
    <!-- <PaidPassengers v-model="paidPassengers" :required="!searchMode" :searchCond="searchMode"/> -->
    <Numeric v-model="paidPassengers" label="有償旅客数" placeholder="0～999999" prop="paid_passengers" :required="!searchMode" :searchCond="searchMode"  :disabled="editDisabledMode" :min="0" :max="999999" :step="1"/>
    <!-- <PaidFlights v-model="paidFlights" :searchCond="searchMode"/> -->
    <Numeric v-model="paidFlights" label="有償飛行件数" placeholder="0～999" prop="paid_flights" :searchCond="searchMode" :disabled="editDisabledMode" :min="0" :max="999" :step="1"/>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
// import PaidFlights from '@/components/molecules/form/number/PaidFlights.vue'
// import Seats from '@/components/molecules/form/number/Seats.vue'
// import PaidPassengers from '@/components/molecules/form/number/PaidPassengers.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import AircraftWeightType from '@/components/molecules/form/select/AircraftWeightType.vue'

export default {
  components: {
    BillingYm,
    BillToCode,
    AirportCode,
    // PaidFlights,
    // Seats,
    // PaidPassengers,
    Numeric,
    AircraftWeightType
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    // billingYmMode: String,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    departureAirportCode: {
      get () {
        return this.model.departure_airport_code
      },
      set (departureAirportCode) {
        const form = { ...this.model }
        form.departure_airport_code = departureAirportCode
        this.$emit('input', form)
      }
    },
    paidFlights: {
      get () {
        return this.model.paid_flights
      },
      set (paidFlights) {
        const form = { ...this.model }
        form.paid_flights = paidFlights
        this.$emit('input', form)
      }
    },
    seats: {
      get () {
        return this.model.seats
      },
      set (seats) {
        const form = { ...this.model }
        form.seats = seats
        this.$emit('input', form)
      }
    },
    paidPassengers: {
      get () {
        return this.model.paid_passengers
      },
      set (paidPassengers) {
        const form = { ...this.model }
        form.paid_passengers = paidPassengers
        this.$emit('input', form)
      }
    },
    aircraftWeightType: {
      get () {
        return this.model.aircraft_weight_type
      },
      set (aircraftWeightType) {
        const form = { ...this.model }
        form.aircraft_weight_type = aircraftWeightType
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    decisionDisabled () {
      var result = false
      if (this.$loginuser.get('role_id').indexOf('airline') !== -1) {
        result = true
        this.model.bill_to_code = this.$loginuser.get('customer_code')
      }
      return result
    },
    clearFields () {
      this.$refs.landingPassengersDataForm.resetFields()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.landingPassengersDataForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.landing-passengers-data-form {
  .el-form-item{
    .el-input__inner{
      width: 15em;
    }
  }
}
</style>
